export default __webpack_public_path__ + "static/twitter-f38a76a486bb48c26c43014d3f4fde32.png";